(function () {
  'use strict';

  angular
    .module('neo.services')
    .factory('Distancies', Distancies);

  function Distancies($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + 'configuracio/distancies', {}, {
      query:  { method: 'GET', isArray: true },
      update: { method: 'PUT', isArray: true }
    });
  }
}());
